export default function ValidateSecondName(SecondName, rfvSecondNameId) {
  if (!rfvSecondNameId) {
    rfvSecondNameId = "#LastNameRequired";
  }
  var valid = true;
  if (SecondName.parent().parent().find("#lblPersonNumber").text() == "Organisationsnummer:") {
    return valid;
  }
  var rfvSecondName = SecondName.siblings(rfvSecondNameId);

  rfvSecondName.hide();
  SecondName.removeClass("error");
  if ($.trim(SecondName.val()).length == 0) {
    valid = false;
    rfvSecondName.show();
    SecondName.addClass("error");
  }
  return valid;
}